import { ChevronLeft, ChevronRight } from 'lucide-react';

interface Props {
  page: number;
  pageSize: number;
  total: number;
  onPage: (p: number) => void;
  size?: 'sm' | 'md';
  className?: string;
}

/** Gmail-style "1–50 of 247" pagination control */
export function GmailPagination({ page, pageSize, total, onPage, size = 'sm', className = '' }: Props) {
  if (total <= 0) return null;
  const lastPage = Math.max(1, Math.ceil(total / pageSize));
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  const sz = size === 'sm' ? 'text-xs' : 'text-sm';
  return (
    <div className={`flex items-center gap-2 ${sz} text-slate-600 ${className}`}>
      <span className="tabular-nums">{start.toLocaleString()}–{end.toLocaleString()} of {total.toLocaleString()}</span>
      <button onClick={() => onPage(page - 1)} disabled={page <= 1}
        className="w-7 h-7 rounded hover:bg-slate-100 flex items-center justify-center disabled:opacity-30 disabled:hover:bg-transparent"
        title="Previous page"><ChevronLeft size={14} /></button>
      <button onClick={() => onPage(page + 1)} disabled={page >= lastPage}
        className="w-7 h-7 rounded hover:bg-slate-100 flex items-center justify-center disabled:opacity-30 disabled:hover:bg-transparent"
        title="Next page"><ChevronRight size={14} /></button>
    </div>
  );
}
